/**
 * دامنه‌ی سایت مرجع ثبت‌نام — خودکار، بدون نیاز به پارامتر در آدرس.
 *
 * هنگام نخستین بارگذاری کلاینت (پیش از هر ریدایرکت داخلی به ورود/ثبت‌نام) فقط دامنه‌ی سایتی که کاربر از آن
 * آمده ثبت می‌شود (از document.referrer؛ ارجاع از خود کلاینت نادیده گرفته می‌شود). اگر لینک پارامتر
 * ?ref= / utm_source / source داشت، همان مقدار اولویت دارد.
 *
 * اولین مرجع (first-touch) در مرورگر نگه داشته می‌شود؛ پس ریدایرکت به /account/login یا /account/register،
 * بارگذاری مجدد یا جابه‌جایی بین صفحه‌ها آن را از بین نمی‌برد. در ثبت‌نام همراه درخواست فرستاده و پس از
 * ثبت موفق پاک می‌شود. سرور مقدار را به دامنه‌ی تمیز تبدیل و روی پروفایل کاربر ذخیره می‌کند.
 */
const KEY = "bndbs.signup.source.v2";

function read() {
    try {
        return window.localStorage.getItem(KEY) || null;
    } catch (e) {
        return null;
    }
}

function referrerDomain() {
    const ref = document.referrer || "";
    if (!ref) return null;
    try {
        const u = new URL(ref);
        if (u.host === window.location.host) return null;
        if (u.protocol !== "http:" && u.protocol !== "https:") return null;
        return u.hostname.replace(/^www\./, "");
    } catch (e) {
        return null;
    }
}

/** یک‌بار هنگام بارگذاری برنامه (پیش از نصب router) صدا زده می‌شود. */
export function captureSignupSource() {
    try {
        if (read()) return; // first-touch
        const params = new URLSearchParams(window.location.search);
        const domain = params.get("ref") || params.get("utm_source") || params.get("source") || referrerDomain();
        if (domain) window.localStorage.setItem(KEY, domain.slice(0, 200));
    } catch (e) {
        /* حالت خصوصی / فضای پر — مرجع فقط اطلاعات کمکی است */
    }
}

/** فیلدی که به درخواست ثبت‌نام اضافه می‌شود. */
export function signupSourcePayload() {
    const s = read();
    return s ? { Source: s } : {};
}

export function clearSignupSource() {
    try {
        window.localStorage.removeItem(KEY);
    } catch (e) {
        /* noop */
    }
}
